import type {SavedView} from './types'

/**
 * Resolves the DOM element that should receive focus after a row is deleted,
 * given the target id picked by `pickPostDeleteFocusTargetId`.
 */
export function resolvePostDeleteFocusTarget(
  target: SavedView['id'] | 'heading',
  container: HTMLElement | null,
): HTMLElement | null {
  if (target !== 'heading') {
    const link = container?.querySelector<HTMLElement>(`[data-saved-view-id="${target}"]`)
    if (link) return link
  }

  const heading =
    document.querySelector<HTMLElement>('main h1, [role="main"] h1') ??
    document.querySelector<HTMLElement>('h1:not(.Overlay-title)')
  if (heading && !heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1')
  return heading
}
